<script setup>
import { ref } from "vue";
import { FormModal } from "@Components/Modal";
import { FormInput } from "@Components/Form";
import { PrimaryButton } from "@Components/Button";
import { useI18n } from "vue-i18n";
import { useForm } from "@/form";
import ActionMessage from "@Components/ActionMessage.vue";
import { useStore } from "@/Stores/templates";

const props = defineProps(["generation"]);

const { t: __ } = useI18n();

const modal = ref();
const templatesStore = useStore();

const form = useForm({
    name: "",
    generation: props.generation.data(),
});

const show = () => {
    modal.value?.show();
};

const hide = () => {
    modal.value?.hide();
};

const submit = async () => {
    form.generation = props.generation.data();
    await form.post("single_mode_save_template");

    templatesStore.fetch();
    hide();
};

defineExpose({ show, hide });
</script>

<template>
    <FormModal @submit="submit" ref="modal" :title="__('Enregistrer le template')">
        <template #body>
            <div class="space-y-6">
                <FormInput v-model="form.name" :label="__('Nom du template')" :z="1" :errors="form.getErrors('name')" />
            </div>
        </template>
        <template #actions>
            <div class="flex justify-end items-center">
                <ActionMessage :on="form.recentlySuccessful" class="mr-3"> {{ __("Sauvegardé.") }} </ActionMessage>
                <PrimaryButton :processing="form.processing" type="submit" :z="1">
                    {{ __("Sauvegarder") }}
                </PrimaryButton>
            </div>
        </template>
    </FormModal>
</template>
